import Form from "./Form";
import ReviewsInfo from "./ReviewsInfo";
import React from "react";
import "./css/gamesStoreParser.css"

export default function GameStoreParser(props) {
    // let countGooglePlayLanguages = 0;
    let countGooglePlayLanguageCodes = 0;
    let countAppStoreCountriesCodes = 0;
    let countSteamLanguages = 0;
    let locRegex = /\b(Íslensku|Übersetzung|översättning|þýðing|Česky|İngilizce|Γλώσσα|Ελληνικά|αγγλικά|εντοπισμός|μετάφραση|граммат|локализ|опечат|орфогр|перевед|перевел|перевод|пунктуа|русск|субтитр|язык|אנגלית|לוקליזציה|עברית|שָׂפָה|תִרגוּם|الإنجليزية|العربية|الموقع|ترجمة|لغة|अंग्रेजी|अनुवाद|भाषा|स्थानीयकरण|हिन्दी|การแปล|การ จำกัด|ภาษา|อังกฤษ|ไทย|中国|中國|局地化|日本|本土化|翻訳|翻譯|翻译|英語|英语|言語|語言|语言|번역|언어|영어|지방화|한국| çeviri | dil | grammatical | grammatically | taal |Anglický|Deutsch|Engels|Englisch|Français|Italiano|Jazyk|Kieli|Lokalisierung|Lokalizacja|Melayu|Nederlands|Portugues|Språk|Sprache|Sprog|Türk|Tiếng Việt|Traduction|angielski|anglais|bahasa|bahasa inggeris|dịch|dansk|engelsk|engelska|englanti|english|ensku|español|idioma|indonesia|inggris|inglés|inglês|inglese|język|käännös|língua|la langue|language|lingua|localis|localisation|localiz|localização|localización|localizzazione|lokalisatie|lokalisering|lokalisointi|lokalizace|nội địa hoá|ngôn ngữ|norsk|oversættelse|oversettelse|překlad|penyetempatan|polski|staðsetning|subtitle|suomalainen|svenska|tłumaczenie|terjemahan|tiếng Anh|tradução|traducción|traduzione|translat|tungumál|typo |typos |vertaling|yerelleştirme)\b/gi;
    let voRegex = /\b(Äänet|Ääni|Þulur|Đã lồng tiếng|Đang diễn|Ασύγχρονη αφήγηση|Αφηγητής|Διάλογος|Ηθοποιία φωνής|Ηθοποιός φωνής|Μεταγλωττισμένο|Μεταγλώττιση|Φωνές|Φωνή|Χείλος|актриса|голоса|голос|голос за кадром|диалог|дублировано|дубляж|закадровый перевод|укладка текста|דו-שיח|לדובב|מדובב|משחק|קולות|קול|קריין|קריינות|שחקן|שחקנית|שפה|أصوات|تعليق صوتي|تمثيل|حوار|دبلجة|راوي|شفة|صوت|مدبلج|ممثلة|ممثل|अभिनय|अभिनेता|अभिनेत्री|ओंठ|डब|डब किया हुआ|प्रस्तुतकर्ता|वॉएसओवर|वॉएसेस|वॉएस|संवाद|การแสดง|นักแสดงชาย|นักแสดงหญิง|บทสนทนา|ผู้บรรยาย|พากย์|ริมฝีปาก|เสียงบรรยาย|เสียงพากย์|เสียง|ナレーター|ボイスオーバー|リップ|会話|吹き替え版|吹き替え|声優|声音|声|女配音|对口型|对白|對嘴|對話|已配音|旁白員|旁白|演技|男配音|聲音|解说员|配音員|配音|饰演|내레이터|대화|더빙됨|더빙|립|보이스오버|연기자|연기|음성| актер | актёр | Ret | Ses | Stem | actor | actors |Acteerwerk|Acteur|Actrice|Actriz|Aktör|Akting|Aktor|Aktorka|Aktorstwo|Aktris|Alih suara|Anlatıcı|Ator|Atriz|Berättare|Berättarröst|Berlakon|Bibir|Commentaire|Dab|Dabovaný|Diálogo|Diễn viên nữ|Diễn viên nam|Dialih suara|Dialog|Dialogi|Dialogue|Dialoog|Diyalog|Doblado|Doblaje|Dobrado|Dobrar|Doublé|Doublage|Dubattu|Dubba|Dubbad|Dubbaus|Dubbet tale|Dubbing|Dubbingować|Dubbingowany|Dublaj|Dublajlı|Dudak|Eftersynkronisation|Eftersynkroniseret|Erzähler|Fortæller|Forteller|Fortellerstemme|Głos|Głosy|Giọng nói|Hội thoại|Herečka|Herec|Hlas|Hlasy|Hraní|Huuli|Interprétation|Interpretação|Interpretación|Kertoja|Komentář|Lábio|Läpp|Lồng tiếng|Leika|Leikari|Leikkona|Lip|Lippe|Lipsynchronisatie|Môi|Näytellä|Näyttelijä|Näyttelijätär|Nagesynchroniseerd|Narator|Narrateur|Narrator|Nasynchronisatie|Người tường thuật|Off-Stimme|Oyunculuk|Pelakon lelaki|Pelakon perempuan|Pengisah|Rödd|Röst|Röster|Raddir|Selostus|Seslendirme|Sesler|Sincronización labial|Skådespelare|Skådespeleri|Skådespelerska|Skuespil|Skuespill|Skuespiller|Skuespillerinne|Stemme|Stemmen|Stemmer|Stimme|Stimmen|Suara|Suara latar|Suara-suara|Synchronisation|Synchronisation labiale|Synchronisieren|Synchronisiert|Synchronsprecher|Synchronsprecherin|Talsetja|Talsetning|Talsett|Thuyết minh|Usta|Vör|Verteller|Viðræður|Voces|Voice-over|Voiceover|Voix|Voz|Voz en off|Voz-off|Vozes|Vypravěč|Z lektorem|attore|attrice|atuação|dialogo|doppiare|doppiata|doppiato|doppiatore|doppiatrice|dublado|dublar|handelend|labiale|leppe|narrador|narratore|narratrice|recitazione|sincronia labial|voce|voce fuori campo|voci)\b/gi;
    let artRegex = /\b(16\-bit|2.5D|32\-bit graphics?|3D Max|8\-bit|AfterEffects?|Aseprite|Blender|DPI|FPS|Flash|GUI|Game Maker|Godot|IPs?|Illustrator|JPG|Maya|NPC|PNG|PSD|PhotoShop|(Sans )?Serif|TIF|UE4|UE5|UI|UV mappings?|UX|Unity|Unreal Engine|VFX|accessibility feature|alpha channel|anchor point|anime|antialias(e|ation|ing)|app preview video|art guide|aspect ratio|asset|attention hook|background|banner ad|blend mode|bones?|brightness|brush(es|ed|ing)?|bug|cameras?( follow| following| follows| view| viewing| views)?|canvas|cartoon|casual|cel[ \-]?shading|character (design|set|art)|collision shape|colou?r (blindness|harmony|harmonies|palette|scheme|sketch)|comic|compositing|concept art|content pack|contrast|conversion|cosmetic|critical|crunch|custom font|cutscene|definition|degrad(e|ation)|demographics|deuteranopia|digital brush|dither(ing)?|downscale|engine|environment art|esthetics|fad(es|ing|ed) in|fad(es|ing|ed) out|featuring|first\-person|font|frame animation|frame count|framerate|freelance|freeze|functional|game design|glitch|graphic|greyscal(e|ing)|hi(gh|gher|ghest)?[ \-]?resolution|hi(gh|gher|ghest)?[ \-]?res|high[ \-]?poly?|hue|hyperrealism|impression|in[ \-]?game art|in[ \-]?house|in[ \-]?game art|isometric|italic|killer feature|landscape|launch|layers?( group)?|level design|line sketch|loading screen|low[ \-]?poly?|low[ \-]?res(olution)?|luminosity|marketing( art)?|materials?|mocap|mockup|modelling|monochromatic|monospace|moodboard|motion captur(e|ing)|motion design|onion skin animation|opacity|optimi[sz]ation|orientation|origin point|outsourc(e|ing)|particle effect|pathfinding algorithm|pen|ink|performance|perspective|pixel art|pixel density|playable ad|playtest(ing)?|polygon count|polygon mesh|portrait|pos(e|ing|es|ed)|pre[ \-]?render|pre[ \-]?loader|production|props?|prototype|pseudo 3D|raster(i[sz]e|i[sz]ing)|raycast(ing)?|ready\-made asset|realism|rectangle|refboard|reference|refs|release|render|resize|resolution|retain(s|ing)? transparency|retain(s|ing)? transparencies|retention|rewarded ad|saturation|scene|screenflow|semi\-realism*|setting|shader|side\-view|sketch|skinning|sound design|spine animation|splash screen|split into frames|sprite|spritesheet|square|stamp|stock asset|styli[sz]ed realism|technical artist|textur(ing|e|e atlas|e map)|theme|third\-person|tile|tileset|toolset|top\-down|tracing|traffic|trailer|transform animation|triadic|truetype|upscal(e|ing)|vector|vectori[sz](e|ing)|vertex|vertical slice|visual coherence|visual feedback|voxel|watercolou?r|wireframe|world build(ing)?)\b/gi

    const authorizationCookieName = "b24_authorization_log"
    const authorizationCookieMatches = document.cookie.match(new RegExp(
        "(?:^|; )" + authorizationCookieName.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    const employeeId = authorizationCookieMatches ?
        +JSON.parse(window.atob(decodeURIComponent(authorizationCookieMatches[1]))).userId :
        window.location.href.split("/")[2] === "localhost:3000" ? 191 : 0

    const [gameStores, setGameStores] = React.useState([
        {
            id: 'googlePlay', name: 'Google Play', checked: false, infoOnGet: false, infoReady: false, /*removeEnglish: false,*/
            data: [], keywordsSearch: false, keywordsSearchType: "loc", keywordsSearchData: [],
            searchLocReviews: false, locReviewsData: [], appName: "", appId: "", reviewsCount: 0,
            languageList: [
                {id: "arabic", name: "Arabic", languageCodes: [
                    {code: "AR", checked: true}
                ]},
                {id: "chineseSimpl", name: "Chinese (Simpl)", languageCodes: [
                    {code: "ZH-CN", checked: true}
                ]},
                {id: "chineseTrad", name: "Chinese (Trad)", languageCodes: [
                    {code: "ZH-TW", checked: true},
                    {code: "ZH-HK", checked: true}
                ]},
                {id: "czech", name: "Czech", languageCodes: [
                    {code: "CS", checked: true}
                ]},
                {id: "danish", name: "Danish", languageCodes: [
                    {code: "DA", checked: true}
                ]},
                {id: "dutch", name: "Dutch", languageCodes: [
                    {code: "NL", checked: true}
                ]},
                {id: "english", name: "English", languageCodes: [
                    {code: "EN", checked: true}
                ]},
                {id: "finnish", name: "Finnish", languageCodes: [
                    {code: "FI", checked: true}
                ]},
                {id: "french", name: "French", languageCodes: [
                    {code: "FR", checked: true}
                ]},
                {id: "german", name: "German", languageCodes: [
                    {code: "DE", checked: true}
                ]},
                {id: "greek", name: "Greek", languageCodes: [
                    {code: "EL", checked: true}
                ]},
                {id: "hebrew", name: "Hebrew", languageCodes: [
                    {code: "HE", checked: true}
                ]},
                {id: "hindi", name: "Hindi", languageCodes: [
                    {code: "HI", checked: true}
                ]},
                {id: "icelandic", name: "Icelandic", languageCodes: [
                    {code: "IS", checked: true}
                ]},
                {id: "indonesian", name: "Indonesian", languageCodes: [
                    {code: "ID", checked: true}
                ]},
                {id: "italian", name: "Italian", languageCodes: [
                    {code: "IT", checked: true}
                ]},
                {id: "japanese", name: "Japanese", languageCodes: [
                    {code: "JA", checked: true}
                ]},
                {id: "korean", name: "Korean", languageCodes: [
                    {code: "KO", checked: true}
                ]},
                {id: "malayan", name: "Malayan", languageCodes: [
                    {code: "MS", checked: true}
                ]},
                {id: "norwegian", name: "Norwegian", languageCodes: [
                    {code: "NO", checked: true}
                ]},
                {id: "polish", name: "Polish", languageCodes: [
                    {code: "PL", checked: true}
                ]},
                {id: "portugueseBR", name: "Portuguese (BR)", languageCodes: [
                    {code: "PT-BR", checked: true}
                ]},
                {id: "portuguesePT", name: "Portuguese (PT)", languageCodes: [
                    {code: "PT-PT", checked: true}
                ]},
                {id: "russian", name: "Russian", languageCodes: [
                    {code: "RU", checked: true}
                ]},
                {id: "spanish", name: "Spanish", languageCodes: [
                    {code: "ES", checked: true}
                ]},
                {id: "swedish", name: "Swedish", languageCodes: [
                    {code: "SV", checked: true}
                ]},
                {id: "thai", name: "Thai", languageCodes: [
                    {code: "TH", checked: true}
                ]},
                {id: "turkish", name: "Turkish", languageCodes: [
                    {code: "TR", checked: true}
                ]},
                {id: "vietnamese", name: "Vietnamese", languageCodes: [
                    {code: "VI", checked: true}
                ]},
            ], allTime: true, dateRange: [{
                startDate: new Date(),
                endDate: new Date(),
                key: 'selection'
            }],
        },
        {
            id: 'appStore', name: 'App Store', checked: false, infoOnGet: false, infoReady: false, /*removeEnglish: false,*/
            data: [], keywordsSearch: false, keywordsSearchType: "loc", keywordsSearchData: [],
            searchLocReviews: false, locReviewsData: [], appName: "", appId: "", reviewsCount: 0,
            countryList: [
                {id: "arabic", name: "Arabic", countryCodes: [
                    {code: "AE", checked: true},
                    {code: "EG", checked: true},
                    {code: "SA", checked: true}
                ]},
                {id: "chineseSimpl", name: "Chinese (Simpl)", countryCodes: [
                    {code: "CN", checked: true},
                    {code: "SG", checked: true}
                ]},
                {id: "chineseTrad", name: "Chinese (Trad)", countryCodes: [
                    {code: "HK", checked: true},
                    {code: "TW", checked: true}
                ]},
                {id: "czech", name: "Czech", countryCodes: [
                    {code: "CZ", checked: true}
                ]},
                {id: "danish", name: "Danish", countryCodes: [
                    {code: "DK", checked: true}
                ]},
                {id: "dutch", name: "Dutch", countryCodes: [
                    {code: "NL", checked: true}
                ]},
                {id: "english", name: "English", countryCodes: [
                    {code: "AU", checked: true},
                    {code: "CA", checked: true},
                    {code: "GB", checked: true},
                    {code: "IE", checked: true},
                    {code: "NZ", checked: true},
                    {code: "US", checked: true}
                ]},
                {id: "finnish", name: "Finnish", countryCodes: [
                    {code: "FI", checked: true}
                ]},
                {id: "french", name: "French", countryCodes: [
                    {code: "FR", checked: true}
                ]},
                {id: "german", name: "German", countryCodes: [
                    {code: "DE", checked: true}
                ]},
                {id: "greek", name: "Greek", countryCodes: [
                    {code: "GR", checked: true}
                ]},
                {id: "hebrew", name: "Hebrew", countryCodes: [
                    {code: "IL", checked: true}
                ]},
                {id: "hindi", name: "Hindi", countryCodes: [
                    {code: "IN", checked: true}
                ]},
                {id: "icelandic", name: "Icelandic", countryCodes: [
                    {code: "IS", checked: true}
                ]},
                {id: "indonesian", name: "Indonesian", countryCodes: [
                    {code: "ID", checked: true}
                ]},
                {id: "italian", name: "Italian", countryCodes: [
                    {code: "IT", checked: true}
                ]},
                {id: "japanese", name: "Japanese", countryCodes: [
                    {code: "JP", checked: true}
                ]},
                {id: "korean", name: "Korean", countryCodes: [
                    {code: "KR", checked: true}
                ]},
                {id: "malayan", name: "Malayan", countryCodes: [
                    {code: "MY", checked: true}
                ]},
                {id: "norwegian", name: "Norwegian", countryCodes: [
                    {code: "NO", checked: true}
                ]},
                {id: "polish", name: "Polish", countryCodes: [
                    {code: "PL", checked: true}
                ]},
                {id: "portugueseBRZ", name: "Portuguese (BRZ)", countryCodes: [
                    {code: "BR", checked: true}
                ]},
                {id: "portugueseEUR", name: "Portuguese (EUR)", countryCodes: [
                    {code: "PT", checked: true}
                ]},
                {id: "russian", name: "Russian", countryCodes: [
                    {code: "BY", checked: true},
                    {code: "RU", checked: true}
                ]},
                {id: "spanish", name: "Spanish", countryCodes: [
                    {code: "ES", checked: true}
                ]},
                {id: "swedish", name: "Swedish", countryCodes: [
                    {code: "SE", checked: true}
                ]},
                {id: "thai", name: "Thai", countryCodes: [
                    {code: "TH", checked: true}
                ]},
                {id: "turkish", name: "Turkish", countryCodes: [
                    {code: "TR", checked: true}
                ]},
                {id: "vietnamese", name: "Vietnamese", countryCodes: [
                    {code: "VN", checked: true}
                ]},
            ], allTime: true, dateRange: [{
                startDate: new Date(),
                endDate: new Date(),
                key: 'selection'
            }]
        },
        {
            id: 'steam', name: 'Steam', checked: false, infoOnGet: false, infoReady: false, /*removeEnglish: false,*/
            data: [], keywordsSearch: false, keywordsSearchType: "loc", keywordsSearchData: [],
            searchLocReviews: false, locReviewsData: [], appName: "", appId: "", languageClearPercent: 0.10,
            languageClearPercentOnInput: 0.10, reviewsCount: 0,
            languageList: [
                {id: "arabic", webId: "ar", name: "Arabic", checked: true},
                {id: "bulgarian", webId: "bg", name: "Bulgarian", checked: true},
                {id: "schinese", webId: "zh-CN", name: "Chinese (Simplified)", checked: true},
                {id: "tchinese", webId: "zh-TW", name: "Chinese (Traditional)", checked: true},
                {id: "czech", webId: "cs", name: "Czech", checked: true},
                {id: "danish", webId: "da", name: "Danish", checked: true},
                {id: "dutch", webId: "nl", name: "Dutch", checked: true},
                {id: "english", webId: "en", name: "English", checked: true},
                {id: "finnish", webId: "fi", name: "Finnish", checked: true},
                {id: "french", webId: "fr", name: "French", checked: true},
                {id: "german", webId: "de", name: "German", checked: true},
                {id: "greek", webId: "el", name: "Greek", checked: true},
                {id: "hungarian", webId: "hu", name: "Hungarian", checked: true},
                {id: "italian", webId: "it", name: "Italian", checked: true},
                {id: "japanese", webId: "ja", name: "Japanese", checked: true},
                {id: "koreana", webId: "ko", name: "Korean", checked: true},
                {id: "norwegian", webId: "no", name: "Norwegian", checked: true},
                {id: "polish", webId: "pl", name: "Polish", checked: true},
                {id: "brazilian", webId: "pt-BR", name: "Portuguese-Brazil", checked: true},
                {id: "portuguese", webId: "pt", name: "Portuguese", checked: true},
                {id: "romanian", webId: "ro", name: "Romanian", checked: true},
                {id: "russian", webId: "ru", name: "Russian", checked: true},
                {id: "latam", webId: "es-419", name: "Spanish-Latin America", checked: true},
                {id: "spanish", webId: "es", name: "Spanish-Spain", checked: true},
                {id: "swedish", webId: "sv", name: "Swedish", checked: true},
                {id: "thai", webId: "th", name: "Thai", checked: true},
                {id: "turkish", webId: "tr", name: "Turkish", checked: true},
                {id: "ukrainian", webId: "uk", name: "Ukrainian", checked: true},
                {id: "vietnamese", webId: "vn", name: "Vietnamese", checked: true}
            ], allTime: true, dateRange: [{
                startDate: new Date(),
                endDate: new Date(),
                key: 'selection'
            }]
        },
    ])

    function storeCLick(id) {
        setGameStores(gameStores.map(store => {
            if (store.id === id) {
                store.checked = !store.checked
            } else {
                store.checked = false
            }

            return store
        }))
    }

    function getReviewsInfo(e) {
        e.preventDefault()
        let appId = e.target.elements.inputAppId.value

        gameStores.map(store => {
            if (store.checked) {
                if (store.id === "googlePlay") {
                    let allCountryCodesCount = countLanguagesLength(store.id, store.languageList)
                    console.log("allCountryCodesCount", allCountryCodesCount)

                    countGooglePlayLanguageCodes = 0

                    setAppId("googlePlay", appId)
                    setInfoReady("googlePlay", false)
                    setInfoOnGet("googlePlay", true)

                    for (let i = 0; i < store.languageList.length; i++) {
                        for (let j = 0; j < store.languageList[i].languageCodes.length; j++) {
                            if (store.languageList[i].languageCodes[j].checked) {
                                googlePlayRekursivelyGetReviews(null, appId, store.languageList[i].languageCodes[j].code,
                                    store.languageList.length, store.languageList[i].name, allCountryCodesCount)
                            }
                        }
                    }
                } else if (store.id === "appStore") {
                    let allCountryCodesCount = countLanguagesLength(store.id, store.countryList)

                    countAppStoreCountriesCodes = 0

                    setAppId("appStore", appId)
                    setInfoReady("appStore", false)
                    setInfoOnGet("appStore", true)

                    for (let i = 0; i < store.countryList.length; i++) {
                        for (let j = 0; j < store.countryList[i].countryCodes.length; j++) {
                            let countryCode = store.countryList[i].countryCodes[j].code

                            if (store.countryList[i].countryCodes[j].checked) {
                                if (!store.allTime || store.keywordsSearch) {
                                    appStoreRekursivelyGetEveryReview(1, appId, countryCode,
                                        store.countryList[i].name, allCountryCodesCount)
                                } else {
                                    appStoreRekursivelyGetReviews(appId, countryCode, store.countryList[i].name,
                                        allCountryCodesCount)
                                }
                            }
                        }
                    }
                } else if (store.id === "steam") {
                    let appName = e.target.elements.inputAppName.value
                    let allLanguagesCount = countLanguagesLength(store.id, store.languageList)

                    countSteamLanguages = 0

                    steamAddAppName(appName)
                    setAppId("steam", appId)
                    setInfoReady("steam", false)
                    setInfoOnGet("steam", true)

                    for (let i = 0; i < store.languageList.length; i++) {
                        if (store.languageList[i].checked) {
                            steamRekursivelyGetReviews("*", appId, store.languageList[i].id, allLanguagesCount)
                        }
                    }
                }
            }

            return store
        })
    }

    function countLanguagesLength(store, languages) {
        let length = 0

        if (store === "steam") {
            for (let i = 0; i < languages.length; i++) {
                if (languages[i].checked) {
                    length++
                }
            }
        } else if (store === "appStore") {
            for (let i = 0; i < languages.length; i++) {
                for (let j = 0; j < languages[i].countryCodes.length; j++) {
                    if (languages[i].countryCodes[j].checked) {
                        length++
                    }
                }
            }
        } else if (store === "googlePlay") {
            for (let i = 0; i < languages.length; i++) {
                for (let j = 0; j < languages[i].languageCodes.length; j++) {
                    if (languages[i].languageCodes[j].checked) {
                        length++
                    }
                }
            }
        }

        return length
    }

    function setSteamLanguageClearPercent(value) {
        setGameStores(gameStores.map(store => {
            if (store.id === "steam") {
                store.languageClearPercent = value;
            }

            return store
        }))
    }

    function setSteamLanguageClearPercentOnInput(e) {
        setGameStores(gameStores.map(store => {
            if (store.id === "steam") {
                store.languageClearPercentOnInput = e.target.elements.inputSteamClearLanguagesPercent.value;
            }

            return store
        }))
    }

    function setAppId(storeName, value) {
        setGameStores(gameStores.map(store => {
            if (store.id === storeName) {
                store.appId = value;
            }

            return store
        }))
    }

    function setInfoReady(storeName, value) {
        setGameStores(gameStores.map(store => {
            if (store.id === storeName) {
                store.infoReady = value;

                if (!value) {
                    store.data = [];
                }
            }

            return store
        }))
    }

    function setInfoOnGet(storeName, value) {
        setGameStores(gameStores.map(store => {
            if (store.id === storeName) {
                store.infoOnGet = value;
            }

            return store
        }))
    }

    async function googlePlayRekursivelyGetReviews(nextPaginationToken, appId, lang, langLength, langName, langCodesLength) {
        const response = await fetch('/proxy/mobile_store_proxy/google_play', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({nextPaginationToken: nextPaginationToken, appId: appId, lang: lang/*, reqId: getRandomSixDigitNumber()*/})
        });

        if ('error' in response) {
            alert("Ошибка " + response.error + " во время получения данных языка " + langName);
        } else {
            let result = await response.json();
            let allTime = true
            let reachBeginningOfTheDateRange = false
            let reachEndOfTheDateRange = false

            // console.log("googlePlayRekursivelyGetReviews", result)

            if (getKeywordsSearchValue("googlePlay")) {
                let allTimeValue = getAllTimeValue("googlePlay")
                let keywordsSearchTypeValue = getKeywordsSearchTypeValue("googlePlay")

                for (let i = 0; i < result.data.length; i++) {
                    let review = result.data[i].text

                    if ((allTimeValue ||
                        (!allTimeValue && checkGooglePlayDateRange(result.data[i].date))) &&
                        typeof review === 'string') {
                        // let review = result.data[i].text
                        let type = ""
                        let foundedKeys = ""
                        let translatedReview = ""
                        let keysExist = false

                        if (keywordsSearchTypeValue === "loc") {
                            let locCheck = checkLocKeys(review)

                            if (locCheck) {
                                keysExist = true

                                let foundedKeysLoc = "LOC: "
                                let locKeysArray = [...review.matchAll(locRegex)]

                                type = "LOC"

                                for (let i = 0; i < locKeysArray.length; i++) {
                                    foundedKeysLoc += locKeysArray[i][0] + "; "
                                }

                                foundedKeys = foundedKeysLoc
                            }
                        } else if (keywordsSearchTypeValue === "vo") {
                            let voCheck = checkVoKeys(review)

                            if (voCheck) {
                                keysExist = true

                                let foundedKeysVo = "VO: "
                                let voKeysArray = [...review.matchAll(voRegex)]

                                type = "VO"

                                for (let i = 0; i < voKeysArray.length; i++) {
                                    foundedKeysVo += voKeysArray[i][0] + "; "
                                }

                                foundedKeys = foundedKeysVo
                            }
                        } else if (keywordsSearchTypeValue === "art") {
                            let artCheck = checkArtKeys(review)

                            if (artCheck) {
                                keysExist = true

                                let foundedKeysArt = "ART: "
                                let artKeysArray = [...review.matchAll(artRegex)]

                                console.log("artKeysArray", artKeysArray)

                                type = "ART"

                                for (let i = 0; i < artKeysArray.length; i++) {
                                    foundedKeysArt += artKeysArray[i][0] + "; "
                                }

                                foundedKeys = foundedKeysArt
                            }
                        }

                        if (keysExist) {
                            let valueToReplace = {
                                userName: result.data[i].userName,
                                language: langName + " (" + lang + ")",
                                text: result.data[i].text,
                                date: result.data[i].date,
                                url: result.data[i].url,
                                score: result.data[i].score,
                                googleTranslation: '',
                                foundedKeys: foundedKeys,
                                type: type
                            }

                            result.data[i] = valueToReplace
                        }
                    }

                    /*if (getAllTimeValue("googlePlay") ||
                        (!getAllTimeValue("googlePlay") && checkGooglePlayDateRange(result.data[i].date))) {
                        let review = result.data[i].text
                        let locCheck = checkLocKeys(review)
                        let voCheck = checkVoKeys(review)

                        if (locCheck || voCheck) {
                            const translateResponse = await fetch('/proxy/mobile_store_proxy/google_cloud_translate', {
                                method: 'POST',
                                headers: {'Content-Type': 'application/json'},
                                body: JSON.stringify({review: review})
                            });
                            let translationResult = await translateResponse.json();
                            let type = ""
                            let foundedKeysLoc = "LOC: "
                            let foundedKeysVo = "VO: "
                            let foundedKeys = ""

                            console.log("LOC VO", i, result.data[i])

                            if (locCheck && voCheck) {
                                let locKeysArray = [...review.matchAll(locRegex)]
                                let voKeysArray = [...review.matchAll(voRegex)]

                                type = "LOC + VO"

                                for (let i = 0; i < locKeysArray.length; i++) {
                                    foundedKeysLoc += locKeysArray[i][0] + "; "
                                }

                                for (let i = 0; i < voKeysArray.length; i++) {
                                    foundedKeysVo += voKeysArray[i][0] + "; "
                                }

                                foundedKeys = foundedKeysLoc + " " + foundedKeysVo
                            } else if (locCheck) {
                                let locKeysArray = [...review.matchAll(locRegex)]

                                type = "LOC"

                                for (let i = 0; i < locKeysArray.length; i++) {
                                    foundedKeysLoc += locKeysArray[i][0] + "; "
                                }

                                foundedKeys = foundedKeysLoc
                            } else if (voCheck) {
                                let voKeysArray = [...review.matchAll(voRegex)]

                                type = "VO"

                                for (let i = 0; i < voKeysArray.length; i++) {
                                    foundedKeysVo += voKeysArray[i][0] + "; "
                                }

                                foundedKeys = foundedKeysVo
                            }

                            let valueToReplace = {
                                userName: result.data[i].userName,
                                language: langName + " (" + lang + ")",
                                text: result.data[i].text,
                                date: result.data[i].date,
                                url: result.data[i].url,
                                score: result.data[i].score,
                                googleTranslation: translationResult.translation,
                                foundedKeys: foundedKeys,
                                type: type
                            }

                            result.data[i] = valueToReplace
                        }
                    }*/
                }
            }

            setGameStores(gameStores.map(store => {
                if (store.id === "googlePlay") {
                    for (let i = 0; i < result.data.length; i++) {
                        allTime = store.allTime

                        if (store.allTime) {
                            let dataItem = {
                                /*"user":  result.data[i].userName,
                                "date": result.data[i].date,
                                "review": result.data[i].text,
                                "link": result.data[i].url,*/
                                "language": langName + " (" + lang + ")",
                                "score": result.data[i].score
                            };

                            store.data.push(dataItem);

                            if ('googleTranslation' in result.data[i]) {
                                let locReview = {
                                    "user": result.data[i].userName,
                                    "date": result.data[i].date,
                                    "review": result.data[i].text,
                                    "link": result.data[i].url,
                                    "language": langName + " (" + lang + ")",
                                    "rating": result.data[i].score,
                                    "foundedKeys": result.data[i].foundedKeys,
                                    "type": result.data[i].type
                                };

                                store.keywordsSearchData.push(locReview);
                            }
                        } else {
                            if (checkGooglePlayDateRange(result.data[i].date)) {
                                reachBeginningOfTheDateRange = true

                                let dataItem = {
                                    /*"user":  result.data[i].userName,
                                    "date": result.data[i].date,
                                    "review": result.data[i].text,
                                    "link": result.data[i].url,*/
                                    "language": langName + " (" + lang + ")",
                                    "score": result.data[i].score
                                };

                                store.data.push(dataItem);

                                if ('googleTranslation' in result.data[i]) {
                                    let locReview = {
                                        "user": result.data[i].userName,
                                        "date": result.data[i].date,
                                        "review": result.data[i].text,
                                        "link": result.data[i].url,
                                        "language": langName + " (" + lang + ")",
                                        "rating": result.data[i].score,
                                        "foundedKeys": result.data[i].foundedKeys,
                                        "type": result.data[i].type
                                    };

                                    store.keywordsSearchData.push(locReview);
                                }
                            } else if (reachBeginningOfTheDateRange) {
                                reachEndOfTheDateRange = true

                                break
                            }
                        }
                    }

                    store.reviewsCount += result.data.length;
                }

                return store
            }))

            if (allTime) {
                if (result.nextPaginationToken) {
                    googlePlayRekursivelyGetReviews(result.nextPaginationToken, appId, lang, langLength, langName, langCodesLength);
                } else {
                    if (countGooglePlayLanguageCodes === (langCodesLength - 1)) {
                        setInfoOnGet("googlePlay", false);
                        setInfoReady("googlePlay", true);
                    } else {
                        countGooglePlayLanguageCodes++;
                    }
                }
            } else {
                if (result.nextPaginationToken &&
                    (!reachBeginningOfTheDateRange || (reachBeginningOfTheDateRange && !reachEndOfTheDateRange))) {
                    googlePlayRekursivelyGetReviews(result.nextPaginationToken, appId, lang, langLength, langName, langCodesLength);
                } else {
                    if (countGooglePlayLanguageCodes === (langCodesLength - 1)) {
                        setInfoOnGet("googlePlay", false);
                        setInfoReady("googlePlay", true);
                    } else {
                        countGooglePlayLanguageCodes++;
                    }
                }
            }
        }
    }


    function getRandomSixDigitNumber() {
        return Math.floor(100000 + Math.random() * 900000)
    }

    async function appStoreRekursivelyGetEveryReview(page, appId, countryCodes, countryName, countryCodesLength) {
        const response = await fetch('/proxy/mobile_store_proxy/app_store_every_reviews', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({appId: appId, countryCodes: countryCodes, page: page})
        });

        if ('error' in response) {
            alert("Ошибка " + response.error + " во время получения данных языка " + countryName + " - " + countryCodes);
        } else {
            let result = await response.json();
            let allTime = true
            let reachBeginningOfTheDateRange = false
            let reachEndOfTheDateRange = false

            console.log("appStoreRekursivelyGetEveryReview result", result)

            if (getKeywordsSearchValue("appStore")) {
                let allTimeValue = getAllTimeValue("appStore")
                let keywordsSearchTypeValue = getKeywordsSearchTypeValue("appStore")

                for (let i = 0; i < result.length; i++) {
                    if (allTimeValue ||
                        (!allTimeValue && checkAppStoreDateRange(result[i].updated))) {
                        let review = result[i].text
                        let type = ""
                        let foundedKeys = ""
                        let keysExist = false

                        if (keywordsSearchTypeValue === "loc") {
                            let locCheck = checkLocKeys(review)

                            if (locCheck) {
                                keysExist = true

                                let foundedKeysLoc = "LOC: "
                                let locKeysArray = [...review.matchAll(locRegex)]

                                type = "LOC"

                                for (let i = 0; i < locKeysArray.length; i++) {
                                    foundedKeysLoc += locKeysArray[i][0] + "; "
                                }

                                foundedKeys = foundedKeysLoc
                            }
                        } else if (keywordsSearchTypeValue === "vo") {
                            let voCheck = checkVoKeys(review)

                            if (voCheck) {
                                keysExist = true

                                let foundedKeysVo = "VO: "
                                let voKeysArray = [...review.matchAll(voRegex)]

                                type = "VO"

                                for (let i = 0; i < voKeysArray.length; i++) {
                                    foundedKeysVo += voKeysArray[i][0] + "; "
                                }

                                foundedKeys = foundedKeysVo
                            }
                        } else if (keywordsSearchTypeValue === "art") {
                            let artCheck = checkArtKeys(review)

                            if (artCheck) {
                                keysExist = true

                                let foundedKeysArt = "ART: "
                                let artKeysArray = [...review.matchAll(artRegex)]

                                type = "ART"

                                for (let i = 0; i < artKeysArray.length; i++) {
                                    foundedKeysArt += artKeysArray[i][0] + "; "
                                }

                                foundedKeys = foundedKeysArt
                            }
                        }

                        if (keysExist) {
                            let valueToReplace = {
                                userUrl: result[i].userUrl,
                                language: countryName + " (" + countryCodes + ")",
                                text: result[i].text,
                                updated: result[i].updated,
                                url: result[i].url,
                                score: result[i].score,
                                googleTranslation: '',
                                foundedKeys: foundedKeys,
                                type: type
                            }

                            result[i] = valueToReplace
                        }
                    }
                }
            }

            setGameStores(gameStores.map(store => {
                if (store.id === "appStore") {
                    for (let i = 0; i < result.length; i++) {
                        allTime = store.allTime

                        if (store.allTime) {
                            let dataItem = {
                                /*"user":  result.data[i].userName,
                                "date": result.data[i].date,
                                "review": result.data[i].text,
                                "link": result.data[i].url,*/
                                "id": countryCodes,
                                "name": countryName,
                                "language": countryName + " (" + countryCodes + ")",
                                "score": result[i].score
                            };

                            store.data.push(dataItem);

                            if ('googleTranslation' in result[i]) {
                                let locReview = {
                                    "user": result[i].userName,
                                    "date": result[i].updated,
                                    "review": result[i].text,
                                    "link": result[i].url,
                                    "language": countryName + " (" + countryCodes + ")",
                                    "rating": result[i].score,
                                    "foundedKeys": result[i].foundedKeys,
                                    "type": result[i].type
                                };

                                store.keywordsSearchData.push(locReview);
                            }
                        } else {
                            if (checkAppStoreDateRange(result[i].updated)) {
                                reachBeginningOfTheDateRange = true

                                let dataItem = {
                                    /*"user":  result.data[i].userName,
                                    "date": result.data[i].date,
                                    "review": result.data[i].text,
                                    "link": result.data[i].url,*/
                                    "id": countryCodes,
                                    "name": countryName,
                                    "language": countryName + " (" + countryCodes + ")",
                                    "score": result[i].score
                                };

                                store.data.push(dataItem);

                                if ('googleTranslation' in result[i]) {
                                    let locReview = {
                                        "user": result[i].userName,
                                        "date": result[i].updated,
                                        "review": result[i].text,
                                        "link": result[i].url,
                                        "language": countryName + " (" + countryCodes + ")",
                                        "rating": result[i].score,
                                        "foundedKeys": result[i].foundedKeys,
                                        "type": result[i].type
                                    };

                                    store.keywordsSearchData.push(locReview);
                                }
                            } else if (reachBeginningOfTheDateRange) {
                                reachEndOfTheDateRange = true

                                break
                            }
                        }
                    }

                    console.log("result.length", result.length)

                    store.reviewsCount += /*result.data.length*/result.length;
                }

                return store
            }))

            console.log("gameStores", gameStores)

            if (allTime) {
                if (/*result.length === 50*/page < 10) {
                    appStoreRekursivelyGetEveryReview(++page, appId, countryCodes, countryName, countryCodesLength)
                } else {
                    if (countAppStoreCountriesCodes === (countryCodesLength - 1)) {
                        setInfoOnGet("appStore", false);
                        setInfoReady("appStore", true);
                    } else {
                        countAppStoreCountriesCodes++;
                    }
                }
            } else {
                if (/*result.length === 50*/page < 10 &&
                    (!reachBeginningOfTheDateRange || (reachBeginningOfTheDateRange && !reachEndOfTheDateRange))) {
                    appStoreRekursivelyGetEveryReview(++page, appId, countryCodes, countryName, countryCodesLength)
                } else {
                    if (countAppStoreCountriesCodes === (countryCodesLength - 1)) {
                        setInfoOnGet("appStore", false);
                        setInfoReady("appStore", true);
                    } else {
                        countAppStoreCountriesCodes++;
                    }
                }
            }
        }

        //__________________________________________________________________

        /*if ('error' in response) {
            alert("Ошибка " + response.error + " во время получения данных языка " + countryName + " - " + countryCodes);
        } else {
            let result = await response.json();
            let allTime = true
            let reachBeginningOfTheDateRange = false
            let reachEndOfTheDateRange = false

            if (getSearchLocReviewsValue("appStore")) {
                for (let i = 0; i < result.length; i++) {
                    if (getAllTimeValue("appStore") ||
                        (!getAllTimeValue("appStore") && checkAppStoreDateRange(result[i].updated))) {
                        let review = result[i].text
                        let locCheck = checkLocKeys(review)
                        let voCheck = checkVoKeys(review)

                        if (locCheck || voCheck) {
                            const translateResponse = await fetch('/proxy/mobile_store_proxy/google_cloud_translate', {
                                method: 'POST',
                                headers: {'Content-Type': 'application/json'},
                                body: JSON.stringify({review: review})
                            });
                            let translationResult = await translateResponse.json();
                            let type = ""
                            let foundedKeysLoc = "LOC: "
                            let foundedKeysVo = "VO: "
                            let foundedKeys = ""

                            console.log("LOC VO", i, result[i], translationResult.translation)

                            if (locCheck && voCheck) {
                                let locKeysArray = [...review.matchAll(locRegex)]
                                let voKeysArray = [...review.matchAll(voRegex)]

                                type = "LOC + VO"

                                for (let i = 0; i < locKeysArray.length; i++) {
                                    foundedKeysLoc += locKeysArray[i][0] + "; "
                                }

                                for (let i = 0; i < voKeysArray.length; i++) {
                                    foundedKeysVo += voKeysArray[i][0] + "; "
                                }

                                foundedKeys = foundedKeysLoc + " " + foundedKeysVo
                            } else if (locCheck) {
                                let locKeysArray = [...review.matchAll(locRegex)]

                                type = "LOC"

                                for (let i = 0; i < locKeysArray.length; i++) {
                                    foundedKeysLoc += locKeysArray[i][0] + "; "
                                }

                                foundedKeys = foundedKeysLoc
                            } else if (voCheck) {
                                let voKeysArray = [...review.matchAll(voRegex)]

                                type = "VO"

                                for (let i = 0; i < voKeysArray.length; i++) {
                                    foundedKeysVo += voKeysArray[i][0] + "; "
                                }

                                foundedKeys = foundedKeysVo
                            }

                            let valueToReplace = {
                                userUrl: result[i].userUrl,
                                language: countryName + " (" + countryCodes + ")",
                                text: result[i].text,
                                updated: result[i].updated,
                                url: result[i].url,
                                score: result[i].score,
                                googleTranslation: translationResult.translation,
                                foundedKeys: foundedKeys,
                                type: type
                            }

                            result[i] = valueToReplace
                        }
                    }
                }
            }

            setGameStores(gameStores.map(store => {
                if (store.id === "appStore") {
                    for (let i = 0; i < result.length; i++) {
                        allTime = store.allTime

                        if (store.allTime) {
                            let dataItem = {
                                /!*"user":  result.data[i].userName,
                                "date": result.data[i].date,
                                "review": result.data[i].text,
                                "link": result.data[i].url,*!/
                                "id": countryCodes,
                                "name": countryName,
                                "language": countryName + " (" + countryCodes + ")",
                                "score": result[i].score
                            };

                            store.data.push(dataItem);
                            console.log("APP STORE allTime", result[i], 'googleTranslation' in result[i])

                            if ('googleTranslation' in result[i]) {
                                let locReview = {
                                    "user": result[i].userName,
                                    "date": result[i].updated,
                                    "review": result[i].text,
                                    "googleTranslation": result[i].googleTranslation,
                                    "link": result[i].url,
                                    "language": countryName + " (" + countryCodes + ")",
                                    "rating": result[i].score,
                                    "foundedKeys": result[i].foundedKeys,
                                    "type": result[i].type,
                                    "prob_l+": result[i]["prob_l+"],
                                    "prob_l-": result[i]["prob_l-"],
                                    "prob_rl": result[i].prob_rl,
                                    "prob_yl": result[i].prob_yl
                                };

                                store.locReviewsData.push(locReview);
                            }
                        } else {
                            if (checkAppStoreDateRange(result[i].updated)) {
                                reachBeginningOfTheDateRange = true

                                let dataItem = {
                                    /!*"user":  result.data[i].userName,
                                    "date": result.data[i].date,
                                    "review": result.data[i].text,
                                    "link": result.data[i].url,*!/
                                    "id": countryCodes,
                                    "name": countryName,
                                    "language": countryName + " (" + countryCodes + ")",
                                    "score": result[i].score
                                };

                                store.data.push(dataItem);
                                console.log("APP STORE customTime", result[i], 'googleTranslation' in result[i])

                                if ('googleTranslation' in result[i]) {
                                    let locReview = {
                                        "user": result[i].userName,
                                        "date": result[i].updated,
                                        "review": result[i].text,
                                        "googleTranslation": result[i].googleTranslation,
                                        "link": result[i].url,
                                        "language": countryName + " (" + countryCodes + ")",
                                        "rating": result[i].score,
                                        "foundedKeys": result[i].foundedKeys,
                                        "type": result[i].type,
                                        "prob_l+": result[i]["prob_l+"],
                                        "prob_l-": result[i]["prob_l-"],
                                        "prob_rl": result[i].prob_rl,
                                        "prob_yl": result[i].prob_yl
                                    };

                                    store.locReviewsData.push(locReview);
                                }
                            } else if (reachBeginningOfTheDateRange) {
                                reachEndOfTheDateRange = true

                                break
                            }
                        }
                    }

                    console.log("result.length", result.length)

                    store.reviewsCount += /!*result.data.length*!/result.length;
                }

                return store
            }))

            console.log("gameStores", gameStores)

            if (allTime) {
                if (/!*result.length === 50*!/page < 10) {
                    appStoreRekursivelyGetEveryReview(++page, appId, countryCodes, countryName, countryCodesLength)
                } else {
                    if (countAppStoreCountriesCodes === (countryCodesLength - 1)) {
                        setInfoOnGet("appStore", false);
                        setInfoReady("appStore", true);
                    } else {
                        countAppStoreCountriesCodes++;
                    }
                }
            } else {
                if (/!*result.length === 50*!/page < 10 &&
                    (!reachBeginningOfTheDateRange || (reachBeginningOfTheDateRange && !reachEndOfTheDateRange))) {
                    appStoreRekursivelyGetEveryReview(++page, appId, countryCodes, countryName, countryCodesLength)
                } else {
                    if (countAppStoreCountriesCodes === (countryCodesLength - 1)) {
                        setInfoOnGet("appStore", false);
                        setInfoReady("appStore", true);
                    } else {
                        countAppStoreCountriesCodes++;
                    }
                }
            }
        }*/

        //todo sample
    }

    async function appStoreRekursivelyGetReviews(appId, countryCodes, countryName, countryCodesLength) {
        const response = await fetch('/proxy/mobile_store_proxy/app_store', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({appId: appId, countryCodes: countryCodes})
        });
        let result = await response.json();

        console.log(result);
        if ('error' in result) {
            alert("Ошибка " + result.error + " во время получения данных страны " +
                countryName + " - " + countryCodes);
        } else {
            let dataItem = {
                "id": countryCodes,
                "name": countryName,
                "ratings": result.ratings,
                "histogram": [result.histogram[1], result.histogram[2], result.histogram[3],
                    result.histogram[4], result.histogram[5]]
            }

            setGameStores(gameStores.map(store => {
                if (store.id === "appStore") {
                    store.data.push(dataItem);
                }

                return store
            }))

            if (countAppStoreCountriesCodes === (countryCodesLength - 1)) {
                setInfoReady("appStore", true);
            } else {
                countAppStoreCountriesCodes++;
            }
        }
    }

    async function steamRekursivelyGetReviews(cursor, appId, lang, langLength) {
        let response = await fetch(
            `/appreviews/${appId}?json=1&filter=recent&purchase_type=all&num_per_page=100&cursor=` + cursor + `&language=${lang}`
        );

        if (response.ok) {
            let json = await response.json();
            let allTime = true
            let reachBeginningOfTheDateRange = false
            let reachEndOfTheDateRange = false
            console.log("steam", json)

            if (getKeywordsSearchValue("steam")) {
                let allTimeValue = getAllTimeValue("steam")
                let keywordsSearchTypeValue = getKeywordsSearchTypeValue("steam")

                console.log("KEYWORDS TYPE", keywordsSearchTypeValue)

                for (let i = 0; i < json.reviews.length; i++) {
                    if (allTimeValue ||
                        (!allTimeValue && checkSteamDateRange(json.reviews[i].timestamp_created))) {
                        let review = json.reviews[i].review
                        let type = ""
                        let foundedKeys = ""
                        let keysExist = false

                        if (keywordsSearchTypeValue === "loc") {
                            let locCheck = checkLocKeys(review)

                            if (locCheck) {
                                keysExist = true

                                let foundedKeysLoc = "LOC: "
                                let locKeysArray = [...review.matchAll(locRegex)]

                                type = "LOC"

                                for (let i = 0; i < locKeysArray.length; i++) {
                                    foundedKeysLoc += locKeysArray[i][0] + "; "
                                }

                                foundedKeys = foundedKeysLoc
                            }
                        } else if (keywordsSearchTypeValue === "vo") {
                            let voCheck = checkVoKeys(review)

                            if (voCheck) {
                                keysExist = true

                                let foundedKeysVo = "VO: "
                                let voKeysArray = [...review.matchAll(voRegex)]

                                type = "VO"

                                for (let i = 0; i < voKeysArray.length; i++) {
                                    foundedKeysVo += voKeysArray[i][0] + "; "
                                }

                                foundedKeys = foundedKeysVo
                            }
                        } else if (keywordsSearchTypeValue === "art") {
                            let artCheck = checkArtKeys(review)

                            if (artCheck) {
                                /*const translateResponse = await fetch('/proxy/mobile_store_proxy/google_cloud_translate', {
                                    method: 'POST',
                                    headers: {'Content-Type': 'application/json'},
                                    body: JSON.stringify({review: review})
                                });
                                let translationResult = await translateResponse.json();

                                translatedReview = translationResult.translation*/
                                keysExist = true

                                /*const locVoResponse = await fetch('/proxy/mobile_store_proxy/loc_vo_prob', {
                                    method: 'POST',
                                    headers: {'Content-Type': 'application/json'},
                                    body: JSON.stringify({review: [translationResult.translation]})
                                });*/
                                // let locVoResult = await locVoResponse.json();

                                let foundedKeysArt = "ART: "
                                let artKeysArray = [...review.matchAll(artRegex)]

                                console.log("artKeysArray", artKeysArray)

                                type = "ART"

                                for (let i = 0; i < artKeysArray.length; i++) {
                                    foundedKeysArt += artKeysArray[i][0] + "; "
                                }

                                foundedKeys = foundedKeysArt
                            }
                        }

                        if (keysExist) {
                            //todo timestamp_created->date voted_up->rating
                            let valueToReplace = {
                                author: json.reviews[i].author,
                                language: json.reviews[i].language,
                                review: json.reviews[i].review,
                                timestamp_created: json.reviews[i].timestamp_created,
                                voted_up: json.reviews[i].voted_up,
                                googleTranslation: /*translatedReview*/"",
                                foundedKeys: foundedKeys,
                                type: type
                            }

                            console.log("valueToReplace", valueToReplace)

                            json.reviews[i] = valueToReplace
                        }
                    }
                }

                console.log("json.reviews", json.reviews)
            }

            setGameStores(gameStores.map(store => {
                if (store.id === "steam") {
                    for (let i = 0; i < json.reviews.length; i++) {
                        allTime = store.allTime

                        if (store.allTime) {
                            let dataItem = {
                                /*"user": "https://steamcommunity.com/profiles/" + json.reviews[i].author.steamid + "/",
                                "date": new Date(json.reviews[i].timestamp_created * 1000).toLocaleDateString("en-US"),
                                "review": json.reviews[i].review,
                                "link": "https://steamcommunity.com/profiles/" + json.reviews[i].author.steamid + "/recommended/" + appId + "/",*/
                                "language": getEngSteamId(store.languageList, json.reviews[i].language),
                                "voted_up": json.reviews[i].voted_up
                            };

                            store.data.push(dataItem);

                            if ('googleTranslation' in json.reviews[i]) {
                                let keyReview = {
                                    "user": "https://steamcommunity.com/profiles/" + json.reviews[i].author.steamid + "/",
                                    "date": new Date(json.reviews[i].timestamp_created * 1000).toLocaleDateString("en-US"),
                                    "review": json.reviews[i].review,
                                    "link": "https://steamcommunity.com/profiles/" + json.reviews[i].author.steamid + "/recommended/" + appId + "/",
                                    "language": json.reviews[i].language,
                                    "voted_up": json.reviews[i].voted_up,
                                    "foundedKeys": json.reviews[i].foundedKeys,
                                    "type": json.reviews[i].type
                                };

                                store.keywordsSearchData.push(keyReview);
                            }
                        } else {
                            if (checkSteamDateRange(json.reviews[i].timestamp_created)) {
                                reachBeginningOfTheDateRange = true

                                let dataItem = {
                                    /*"user": "https://steamcommunity.com/profiles/" + json.reviews[i].author.steamid + "/",
                                    "date": new Date(json.reviews[i].timestamp_created * 1000).toLocaleDateString("en-US"),
                                    "review": json.reviews[i].review,
                                    "link": "https://steamcommunity.com/profiles/" + json.reviews[i].author.steamid + "/recommended/" + appId + "/",*/
                                    "language": getEngSteamId(store.languageList, json.reviews[i].language),
                                    "voted_up": json.reviews[i].voted_up
                                };

                                store.data.push(dataItem);

                                if ('googleTranslation' in json.reviews[i]) {
                                    let keyReview = {
                                        "user": "https://steamcommunity.com/profiles/" + json.reviews[i].author.steamid + "/",
                                        "date": new Date(json.reviews[i].timestamp_created * 1000).toLocaleDateString("en-US"),
                                        "review": json.reviews[i].review,
                                        "link": "https://steamcommunity.com/profiles/" + json.reviews[i].author.steamid + "/recommended/" + appId + "/",
                                        "language": json.reviews[i].language,
                                        "voted_up": json.reviews[i].voted_up,
                                        "foundedKeys": json.reviews[i].foundedKeys,
                                        "type": json.reviews[i].type
                                    };

                                    store.keywordsSearchData.push(keyReview);
                                }
                            } else if (reachBeginningOfTheDateRange) {
                                reachEndOfTheDateRange = true

                                break
                            }
                        }
                    }

                    store.reviewsCount += json.reviews.length;
                }

                return store
            }))

            if (allTime) {
                if (cursor !== encodeURIComponent(json.cursor)) {
                    steamRekursivelyGetReviews(encodeURIComponent(json.cursor), appId, lang, langLength)
                } else {
                    if (countSteamLanguages === (langLength - 1)) {
                        setInfoOnGet("steam", false);
                        setInfoReady("steam", true);
                    } else {
                        countSteamLanguages++;
                    }
                }
            } else {
                //не достигли диапазона !reachBeginningOfTheDateRange - идем дальше
                //достигли диапазона и закончили reachBeginningOfTheDateRange && reachEndOfTheDateRange - закончили
                //достигли диапазона и не закончили reachBeginningOfTheDateRange && !reachEndOfTheDateRange - идем дальше
                //закончили reachEndOfTheDateRange - закончили
                if (cursor !== encodeURIComponent(json.cursor) &&
                    (!reachBeginningOfTheDateRange || (reachBeginningOfTheDateRange && !reachEndOfTheDateRange))) {
                    steamRekursivelyGetReviews(encodeURIComponent(json.cursor), appId, lang, langLength);
                } else {
                    if (countSteamLanguages === (langLength - 1)) {
                        setInfoOnGet("steam", false);
                        setInfoReady("steam", true);
                    } else {
                        countSteamLanguages++;
                    }
                }
            }
        } else {
            alert("Ошибка HTTP: " + response.status + " во время получения данных языка " + lang);
        }
    }

    function steamAddAppName(name) {
        setGameStores(gameStores.map(store => {
            if (store.id === "steam") {
                store.appName = name;
            }

            return store
        }))
    }

    function getEngSteamId(steamArr, id) {
        for (let i = 0; i < steamArr.length; i++) {
            if (steamArr[i].id === id) {
                return steamArr[i].name;
            }
        }
    }

    function setSelectedLanguagesMultiselect(storeName, value) {
        setGameStores(gameStores.map(store => {
            if (store.id === storeName) {
                if (storeName === "steam") {
                    store.languageList.map(language => {
                        language.checked = value.includes(language.id)
                    })
                } else if (storeName === "appStore") {
                    console.log("CHECKED", value)

                    store.countryList.map(country => {
                        country.countryCodes.map(code => {
                            let includedValue = {country: country.id, code: code.code}

                            code.checked = value.some(item => JSON.stringify(item) === JSON.stringify(includedValue))
                        })
                    })
                } else if (storeName === "googlePlay") {
                    console.log("CHECKED", value)

                    store.languageList.map(language => {
                        language.languageCodes.map(code => {
                            let includedValue = {language: language.id, code: code.code}

                            code.checked = value.some(item => JSON.stringify(item) === JSON.stringify(includedValue))
                        })
                    })
                }
            }

            return store
        }))
    }

    function setAllTime(storeName) {
        setGameStores(gameStores.map(store => {
            if (store.id === storeName) {
                store.allTime = !store.allTime
            }

            return store
        }))
    }

    function setDateRange(storeName, range) {
        setGameStores(gameStores.map(store => {
            if (store.id === storeName) {
                store.dateRange = range
            }

            return store
        }))
    }

    function setKeywordsSearch(storeName) {
        setGameStores(gameStores.map(store => {
            if (store.id === storeName) {
                store.keywordsSearch = !store.keywordsSearch
            }

            return store
        }))
    }

    function setKeywordsSearchType(storeName, type) {
        console.log("CHANGE KEY TYPE", type)

        setGameStores(gameStores.map(store => {
            if (store.id === storeName) {
                store.keywordsSearchType = type
            }

            return store
        }))
    }

    function checkSteamDateRange(reviewDate) {
        let check

        setGameStores(gameStores.map(store => {
            let startDate
            let endDate

            if (store.id === "steam") {
                startDate = store.dateRange[0].startDate.getTime() / 1000
                endDate = store.dateRange[0].endDate.getTime() / 1000 + 86400

                check = reviewDate >= startDate && reviewDate <= endDate
            }

            return store
        }))

        return check
    }

    function checkGooglePlayDateRange(reviewDate) {
        let check

        setGameStores(gameStores.map(store => {
            let startDate
            let endDate

            if (store.id === "googlePlay") {
                startDate = store.dateRange[0].startDate.getTime() / 1000
                endDate = store.dateRange[0].endDate.getTime() / 1000 + 86400
                reviewDate = Date.parse(reviewDate.substr(0, 10)) / 1000

                check = reviewDate >= startDate && reviewDate <= endDate
            }

            return store
        }))

        return check
    }

    function checkAppStoreDateRange(reviewDate) {
        let check

        setGameStores(gameStores.map(store => {
            let startDate
            let endDate

            if (store.id === "appStore") {
                startDate = store.dateRange[0].startDate.getTime() / 1000
                endDate = store.dateRange[0].endDate.getTime() / 1000 + 86400
                reviewDate = Date.parse(reviewDate.substr(0, 10)) / 1000

                check = reviewDate >= startDate && reviewDate <= endDate
            }

            return store
        }))

        return check
    }

    function getKeywordsSearchValue(id) {
        let value = false

        gameStores.map(store => {
            if (store.id === id) {
                value = store.keywordsSearch
            }

            return store
        })

        return value
    }

    function getAllTimeValue(id) {
        let value = false

        gameStores.map(store => {
            if (store.id === id) {
                value = store.allTime
            }

            return store
        })

        return value
    }

    function getKeywordsSearchTypeValue(id) {
        let value = false

        gameStores.map(store => {
            if (store.id === id) {
                value = store.keywordsSearchType
            }

            return store
        })

        return value
    }

    function checkLocKeys(review) {
        let locMatchValue = review.match(locRegex) || []

        return locMatchValue.length;
    }

    function checkVoKeys(review) {
        let voMatchValue = review.match(voRegex) || []

        return voMatchValue.length;
    }

    function checkArtKeys(review) {
        let artMatchValue = review.match(artRegex) || []

        return artMatchValue.length;
    }

    function checkCookie() {
        let name = "testCookie"

        document.cookie = "testCookie=test; max-age=3600";

        let matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));

        if (!matches) {
            alert("Allow cookies in your browser settings for correct work.")

            return false
        } else {
            return employeeId > 0
        }
    }

    function setRedirectCookie() {
        let cookieName =  'apps_allcorrect_redirect'
        let cookieValue = window.btoa(window.location.href)
        let date = new Date(Date.now() + 1800e3);
        let options = {
            path: '/',
            domain: 'allcorrectgames.com',
            expires: date.toUTCString(),
            samesite: 'lax'
        };
        let updatedCookie = cookieName + "=" + cookieValue;

        for (let optionKey in options) {
            updatedCookie += "; " + optionKey;

            let optionValue = options[optionKey];

            if (optionValue !== true) {
                updatedCookie += "=" + optionValue;
            }
        }

        document.cookie = updatedCookie;
    }

    function deleteRedirectCookie() {
        let cookieName =  'apps_allcorrect_redirect'
        let cookieValue = 'val'
        let date = new Date();

        date.setMonth(date.getMonth() - 1);

        let options = {
            path: '/',
            domain: 'allcorrectgames.com',
            expires: date.toUTCString(),
            samesite: 'lax'
        };
        let updatedCookie = cookieName + "=" + cookieValue;

        for (let optionKey in options) {
            updatedCookie += "; " + optionKey;

            let optionValue = options[optionKey];

            if (optionValue !== true) {
                updatedCookie += "=" + optionValue;
            }
        }

        document.cookie = updatedCookie;
    }

    if (checkCookie()) {
        deleteRedirectCookie()

        return (
            <div className="wrapper">
                <Form gameStores={gameStores} storeCLick={storeCLick} getReviewsInfo={getReviewsInfo}
                      setSelectedLanguagesMultiselect={setSelectedLanguagesMultiselect}
                      setAllTime={setAllTime} setDateRange={setDateRange}
                      setKeywordsSearch={setKeywordsSearch} setKeywordsSearchType={setKeywordsSearchType} />
                <br/>
                <ReviewsInfo gameStores={gameStores} setSteamLanguageClearPercent={setSteamLanguageClearPercent}
                             setSteamLanguageClearPercentOnInput={setSteamLanguageClearPercentOnInput}/>
            </div>
        )
    } else {
        setRedirectCookie()
        window.location.replace('https://b24.allcorrectgames.com');
    }
}
